export default __webpack_public_path__ + "locales/sr-Cyrl-RS/About.json?hash=a49f634ddfddbf159ad2d37b423bbf67";